module.exports = __webpack_public_path__ + "images/Instruments_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Instruments_hover.png
// module id = 379
// module chunks = 0 1